import { Grid, Typography } from '@cmg/design-system';
import isNil from 'lodash/isNil';
import React from 'react';

export type Props<TValue extends React.ReactNode> = Readonly<{
  label: string | React.ReactNode;
  value: TValue | null | undefined;
  formatter?: (value: TValue) => React.ReactNode;
}>;

const GridRowPair = <TValue extends React.ReactNode>({
  label,
  value,
  formatter,
}: Props<TValue>) => {
  const formattedValue = React.useMemo<React.ReactNode>(() => {
    let result: React.ReactNode = '-';
    if (!isNil(value)) {
      result = formatter ? formatter(value) : value;
    }
    return result;
  }, [formatter, value]);

  return (
    <Grid container role="row">
      <Grid item xs={5}>
        {typeof label === 'string' ? (
          <Typography color="text.secondary">{label}</Typography>
        ) : (
          label
        )}
      </Grid>
      <Grid item xs={7}>
        {formattedValue}
      </Grid>
    </Grid>
  );
};

export default GridRowPair;
